import React, { useCallback } from 'react';
import { connect } from 'react-redux';
import Select, { components } from 'react-select';
import { withStyles } from '@material-ui/styles';
import { flowRight } from 'lodash';

import { reactSelectDefaultStyles } from '../../../consts/reactSelectDefaultStyles';
import styles, { customSelectStyles } from '../styles/selectClient';
import { actions as reduxActions } from '../reducers';
import Optional from '../../../utils/optional';
import withSettings from '../../../utils/withSettings';
import { isDefined } from '../../../utils/isDefined';

const SelectClient = ({
  clientsOptions = [],
  selectedClient,
  setSelectedClient,
  classes,
  settings
}) => {
  const onClientChange = useCallback(
    selected => {
      if (selected.value !== selectedClient.value) {
        setSelectedClient(selected);
      }
    },
    // eslint-disable-next-line
    [selectedClient.value]
  );

  const ValueContainer = props => {
    const { children, selectProps } = props;
    const [singleValue, input] = children;
    const { menuIsOpen } = selectProps;
    return (
      <components.ValueContainer {...props}>
        {menuIsOpen ? (
          <div className={classes.labelContainer} style={{ direction: 'ltr' }}>
            {input}
          </div>
        ) : (
          <>
            <div className={classes.labelContainer}>
              <div style={{ color: settings.colors.primary }}>
                {Optional(singleValue?.props.data?.display_name).or(
                  singleValue?.props.data?.name
                )}
              </div>
            </div>
            <div style={{ position: 'absolute', width: 0, overflow: 'hidden' }}>
              {input}
            </div>
          </>
        )}
      </components.ValueContainer>
    );
  };

  return (
    isDefined(clientsOptions) && (
      <Select
        styles={reactSelectDefaultStyles}
        customStyles={customSelectStyles}
        options={clientsOptions}
        value={selectedClient}
        onChange={onClientChange}
        isRtl
        isSearchable
        components={{ ValueContainer }}
      />
    )
  );
};

const mapStatesToProps = ({ simCards }) => {
  return {
    selectedClient: simCards.selectedClient
  };
};

const mapDispatchToProps = {
  setSelectedClient: reduxActions.setSelectedClient
};

export default flowRight(
  withSettings,
  connect(mapStatesToProps, mapDispatchToProps),
  withStyles(styles)
)(SelectClient);
